export default [
	{
		category: true,
		title: 'Gestión',
		auth: 'superadmin',
	},
	{
		title: 'Procesos PM2',
		key: 'PM2',
		icon: ['fal', 'server'],
		url: { name: 'pm2' },
		auth: 'superadmin',
	},
	{
		category: true,
		title: 'Aliexpress',
		auth: 'superadmin',
	},
	{
		title: 'Estadísticas',
		key: 'statistics',
		icon: ['fal', 'analytics'],
		url: { name: 'statistics' },
		auth: 'superadmin',
	},
	{
		title: 'Copiar posts',
		key: 'posts-aliexpress',
		icon: ['fal', 'paste'],
		url: { name: 'posts-aliexpress' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'General',
		auth: 'editor',
	},
	{
		title: 'Dashboard',
		key: 'home',
		icon: ['fal', 'tachometer-alt'],
		url: { name: 'home' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Posts',
		auth: 'editor',
	},
	{
		title: 'Todos los posts',
		key: 'posts',
		icon: ['fal', 'ticket-alt'],
		url: { name: 'posts' },
		auth: 'editor',
	},
	{
		title: 'Pte. Moderación',
		key: 'pendingPosts',
		icon: ['fal', 'fist-raised'],
		url: { name: 'pendingPosts' },
		badge: 'pendingPosts',
		auth: 'editor',
	},
	{
		title: 'Nuevo post',
		key: 'postAdd',
		icon: ['fal', 'plus-circle'],
		url: { name: 'postAdd' },
		auth: 'editor',
	},
	{
		title: 'Subir excel',
		key: 'postExcel',
		icon: ['fal', 'file-excel'],
		url: { name: 'postExcel' },
		auth: 'editor',
	},
	{
		title: 'Amazon Excel',
		key: 'excelAmazon',
		icon: ['fal', 'file-excel'],
		url: { name: 'excelAmazon' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Banners',
		auth: 'editor',
	},
	{
		title: 'Todos los banners',
		key: 'banners',
		icon: ['fal', 'megaphone'],
		url: { name: 'banners' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Cupones',
		auth: 'editor',
	},
	{
		title: 'Todos los cupones',
		key: 'coupons',
		icon: ['fal', 'percent'],
		url: { name: 'coupons' },
		auth: 'editor',
	},
	{
		title: 'Pte. Moderación',
		key: 'pendingCoupons',
		icon: ['fal', 'fist-raised'],
		url: { name: 'pendingCoupons' },
		badge: 'pendingCoupons',
		auth: 'editor',
	},
	{
		title: 'Nuevo cupón',
		key: 'couponAdd',
		icon: ['fal', 'plus-circle'],
		url: { name: 'couponAdd' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Tags',
		auth: 'editor',
	},
	{
		title: 'Todas las tags',
		key: 'tags',
		icon: ['fal', 'tags'],
		url: { name: 'tags' },
		auth: 'editor',
	},
	{
		title: 'Nueva tag',
		key: 'tagAdd',
		icon: ['fal', 'plus-circle'],
		url: { name: 'tagAdd' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Estadísticas',
		auth: 'editor',
	},
	{
		title: 'Estadísticas de links',
		key: 'Link-stats',
		icon: ['fal', 'link'],
		url: { name: 'linkStats' },
		auth: 'editor',
	},
	{
		title: 'Estadísticas de tags',
		key: 'Tags-stats',
		icon: ['fal', 'tags'],
		url: { name: 'tagsStats' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Resumen semanal',
		auth: 'editor',
	},
	{
		title: 'Todos los resúmenes',
		key: 'summaries',
		icon: ['fal', 'box-full'],
		// url: { name: 'summaries' },
		event: 'listSummaries',
		auth: 'editor',
	},
	{
		title: 'Nuevo resumen',
		key: 'summaryAdd',
		icon: ['fal', 'plus-circle'],
		url: { name: 'summaryAdd' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Comentarios',
		auth: 'editor',
	},
	{
		title: 'Todos los comentarios',
		key: 'comments',
		icon: ['fal', 'comments-alt'],
		url: { name: 'comments' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Usuarios',
		auth: 'editor',
	},
	{
		title: 'Todos los usuarios',
		key: 'users',
		icon: ['fal', 'users'],
		url: { name: 'users' },
		auth: 'editor',
	},
	{
		category: true,
		title: 'Tracking',
		auth: 'editor',
	},
	{
		title: 'Todos los tracks',
		key: 'tracking',
		icon: ['fal', 'users'],
		url: { name: 'tracking' },
		auth: 'admin',
	},
	{
		category: true,
		title: 'Template Studio',
		auth: 'editor',
	},
	{
		title: 'Crear plantilla',
		key: 'templaterCreate',
		icon: ['fal', 'magic'],
		url: { name: 'templaterCreate' },
		auth: 'editor',
	},
	{
		title: 'Plantillas programadas',
		key: 'templater',
		icon: ['fal', 'calendar-alt'],
		url: { name: 'templater' },
		auth: 'editor',
	},
	{
		title: 'Chat del equipo',
		key: 'chat',
		icon: ['fal', 'comments'],
		url: { name: 'chat' },
		auth: 'editor',
	},
];
